import Button from "@/components/common/Button";
import ConfirmBox from "@/components/common/Confirm";
import Loader from "@/components/common/Loader";
import {useNavigate} from "react-router-dom";
import Box from "../../components/common/Box";
import {useQuery, useQueryClient} from "@tanstack/react-query";
import {Check, X} from "lucide-react";
import React, {useState} from "react";
import API from "@/api";

const Dashboard = () => {
  const [deleteRota, setDeleteRota] = useState(null);

  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const rotasFeed = useQuery({
    queryKey: ["rotas"],
    queryFn: () => API.rotas.list(),
    staleTime: 2000,
    refetchOnWindowFocus: true,
  });

  const reloadData = () => queryClient.invalidateQueries(["rotas"]);

  const handleDeleteRota = async () => {
    return API.rotas.delete(deleteRota._id).then(() => {
      reloadData();
      setDeleteRota(null);
    });
  };

  return (
    <div className="p-4">
      <Box title="Rota's">
        <div className={"p-2 flex justify-end"}>
          <Button
            onClick={() => navigate(`./add`)}
            text={"Add"}
          />
        </div>
        <ConfirmBox
          show={deleteRota !== null}
          onClose={() => setDeleteRota(null)}
          action={handleDeleteRota}
          title={`Deleting this rota will also delete all shift data related to this rota`}
        />
        {rotasFeed.isSuccess ? (
          <div>
            <table className="tableClass">
              <thead className="tableHeadClass">
                <tr className="tableHeadRowClass">
                  <th className="tableHeadCellClass">Title</th>
                  <th className="tableHeadCellClass">Description</th>
                  <th className="tableHeadCellClass">Role</th>
                  <th className="tableHeadCellClass w-20 text-center">Duty Role</th>
                  <th className="tableHeadCellClass">{""}</th>
                </tr>
              </thead>
              <tbody className="tableBodyClass">
                {rotasFeed.data.map((rotaItem, i) => {
                  return (
                    <tr
                      className={`tableBodyRowClass hover:bg-background ${i % 2 && "bg-muted/20"}`}
                      key={i}
                    >
                      <td className="tableBodyCellClass">{rotaItem.title}</td>
                      <td className="tableBodyCellClass">{rotaItem.description}</td>
                      <td className="tableBodyCellClass">{rotaItem.role}</td>
                      <td className="tableBodyCellClass w-20 text-center">
                        {rotaItem.duty ? (
                          <Check className="text-success mx-auto" />
                        ) : (
                          <X className="text-muted-foreground mx-auto" />
                        )}
                      </td>
                      <td className="tableBodyCellClass">
                        <div className="flex justify-end gap-1">
                          <Button
                            onClick={() => navigate(`./${rotaItem._id}/edit`)}
                            text={"Edit"}
                          />
                          <Button
                            onClick={() => setDeleteRota(rotaItem)}
                            text={"Delete"}
                          />
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            {rotasFeed.data.length === 0 && (
              <div className={"m-2"}>
                <div className={"flex justify-center items-center text-white"}>
                  There are no items to display.
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className={"py-5 text-center text-xl"}>
            Loading list...
            <Loader className={"mt-2"}/>
          </div>
        )}
      </Box>
    </div>
  );
}

export default Dashboard;